export default __webpack_public_path__ + "canada.4ac8a00a.png";